import {
    animate,
    style,
    transition,
    trigger,
    query,
    stagger
  } from '@angular/animations';
  
  export const fadeStagger = trigger('fadeStagger', [
    transition(':enter', [
      query(':enter', [
        style({ opacity: 0, transform: 'translateY(10px)' }),
        stagger(100, [
          animate('300ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
        ])
      ])
    ])
  ]);
  
  export const slideIn = trigger('slideIn', [
    transition(':enter', [
      style({ transform: 'translateY(20px)', opacity: 0 }),
      animate('200ms ease-out', style({ transform: 'translateY(0)', opacity: 1 }))
    ]),
    transition(':leave', [
      animate('150ms ease-in', style({ transform: 'translateY(10px)', opacity: 0 }))
    ])
  ]);
  